import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ShortText = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M4 9H20V11H4V9ZM4 13H14V15H4V13Z" />
  </SvgIcon>
));

ShortText.displayName = 'ShortText';

export default ShortText;
